import React from "react";

/**
 * LoadingIndicator - Shows a typing animation while waiting for response
 * @returns {JSX.Element}
 */
const LoadingIndicator = () => {
    return (
        <div className="flex items-center gap-2 px-4 py-3">
            <div className="flex gap-1">
                <span
                    className="w-2 h-2 bg-acs-primary-green rounded-full animate-bounce"
                    style={{ animationDelay: "0ms" }}
                ></span>
                <span
                    className="w-2 h-2 bg-acs-primary-green rounded-full animate-bounce"
                    style={{ animationDelay: "150ms" }}
                ></span>
                <span
                    className="w-2 h-2 bg-acs-primary-green rounded-full animate-bounce"
                    style={{ animationDelay: "300ms" }}
                ></span>
            </div>
            <span className="text-sm text-gray-500">Thinking...</span>
        </div>
    );
};

export default LoadingIndicator;
